import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Paper,
  Box
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const faqData = [
  {
    question: 'What advantages do I get through your AI Platform over traditional trading methods?',
    answer: (
        `
          Our AI Platform transforms the way you source products globally. It <b>screens, verifies, and validates</b> suppliers before matching them to your specific needs - making the entire process <b>faster, more cost-effective,</b> and <b>far less effort-intensive</b> compared to traditional methods.
          <br><br>
          Even better, the platform constantly scans products uploaded by global suppliers and, based on demand in your geography, <b>automatically generates relevant offers</b>. In most cases, you don’t even need to raise a request - personalized offers are already visible on your dashboard, ready for your review.
        `
      )
  },
  {
    question: 'Can the AI Platform accommodate my customized requirements and preferences?',
    answer: (
        `
          Yes, it can. The AI is built to <b>understand the nuances of your business</b> and automatically connects you with the most suitable suppliers. Whether you have specific product needs, quality standards, or delivery timelines, the platform intelligently adapts to deliver what you’re looking for.
          <br><br>
          And if you need support beyond the platform, there’s always a <b>Global Trading Partner - a real person in your region - available to assist you</b> at any stage of the process.
        `
      )
  },
  {
    question: 'Can the AI Platform help me by predicting market trends and price movements?',
    answer: (
        `
          Absolutely. The AI continuously <b>tracks global market activity</b> and analyzes trends to provide you with <b>real-time predictions on price movements</b>. Whether prices are expected to rise or fall, you’ll have the insights you need to make timely and well-informed buying decisions.
        `
      )
  }
];

const BuyerFaqComp = () => {
  return (
    <div className="container">
      <div className="">


        <Box className="container p-2">
          <Paper elevation={1} sx={{ p: 2 }}>
            <div
              className="table-header"
              style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}
            >
              <div className="header-text">
                <div className="head-text">Frequently Asked Questions</div>
              </div>
            </div>

            {faqData.map((faq, index) => (
              <Accordion key={index} sx={{ border: '1px solid #e0e0e0', borderRadius: '6px', mb: 1 }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`faq-content-${index}`}
                  id={`faq-header-${index}`}
                  sx={{
                    backgroundColor: index % 2 === 0 ? '#f5f7fa' : '#e8edf3',
                    fontWeight: 600
                  }}
                >
                  <Typography fontWeight={600}>{faq.question}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ fontSize: '14px' }}
                  >
                    <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Paper>
        </Box>
      </div>
    </div>
  );
};

export default BuyerFaqComp;
